import { render, staticRenderFns } from "./ChangePage.vue?vue&type=template&id=ba0160b6&"
import script from "./ChangePage.vue?vue&type=script&lang=js&"
export * from "./ChangePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports